import { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { actionCreators } from '@makemydeal/dr-offer-redux';
import * as offerReduxSelectors from '@makemydeal/dr-dash-store/selectors/offerRedux';
import * as deskingActionCreators from '@makemydeal/dr-dash-store/actions/deskingActionCreators';
import * as dealScreenErrorActionCreators from '@makemydeal/dr-dash-store/actions/dealScreenErrorActionCreators';
import { dealLockHooks } from '@makemydeal/dr-dash-components';
import { Button } from '@interstate/components/Button';
import { Box } from '@interstate/components/Box';
import { TaxResetDialog } from './TaxResetDialog';
import { ArrowUturnLeftIcon } from '@interstate/components/Icons';
import { featureToggleSelectors } from '@makemydeal/dr-shared-store';
import { DealTabs } from '@makemydeal/dr-shared-types';

type TaxesBottomBarProps = {
    setTaxOverrideFormEdited: (formEdited: boolean) => void;
};
export default function TaxesBottomBar(props: TaxesBottomBarProps) {
    const { setTaxOverrideFormEdited } = props;
    const isTaxResetDisabled = useSelector(offerReduxSelectors.isTaxResetDisabled);
    const offerType = useSelector(offerReduxSelectors.getCurrentOfferType);
    const dispatch = useDispatch();
    const isLocked = dealLockHooks.useIsDealLocked();
    const [showReadyToResetDialog, setShowReadyToResetDialog] = useState(false);
    const useManualTotalTaxEditedFlag = useSelector(featureToggleSelectors.useManualTotalTaxEdited);
    const isDealScreenRedDotErrorsEnabled = useSelector(featureToggleSelectors.isDealScreenRedDotErrorsEnabled);

    const resetTaxes = useCallback(() => {
        dispatch(actionCreators.resetTaxOverrides(offerType));
        if (isDealScreenRedDotErrorsEnabled) {
            dispatch(dealScreenErrorActionCreators.clearEntityErrors(DealTabs.TAXES));
        }
        dispatch(deskingActionCreators.hideTotalTaxRateSupersedeAlert());

        !useManualTotalTaxEditedFlag && setTaxOverrideFormEdited(false);
        setShowReadyToResetDialog(false);
    }, [dispatch, offerType, setTaxOverrideFormEdited]);

    return (
        <Box width="100%" display="flex" alignItems="center" justifyContent="flex-end">
            <Button
                data-testid="taxes-reset-all-btn"
                type="button"
                size="default"
                buttonStyle="tertiary"
                disabled={isTaxResetDisabled || isLocked}
                onClick={() => setShowReadyToResetDialog(true)}
                startIcon={<ArrowUturnLeftIcon />}
            >
                Reset All
            </Button>
            {showReadyToResetDialog && (
                <TaxResetDialog
                    data-testid="reset-tax-dialog"
                    onHide={() => setShowReadyToResetDialog(false)}
                    onCancel={() => setShowReadyToResetDialog(false)}
                    onConfirm={resetTaxes}
                />
            )}
        </Box>
    );
}
